import { Component, OnInit, ViewChild } from "@angular/core";
import { ColumnTypes } from "src/app/shared/Models/enums/ColumnTypeEnum";
import { FilterableTableComponent } from "src/app/shared/table/filterable-table.component";
import { ToastService } from "src/app/shared/toast.service";
import { DeviceCheckService } from "../../survey/shared/services/device-check.service";
import { ExportFieldDto } from "../models/ExportFieldDto";
import { Table } from "primeng/table";
import { ExportFieldService } from "../services/export-fields.service";
import { first } from "rxjs/operators";
import { NavAction } from "src/app/shared/top-nav/top-nav.component";
import { PermissionsService } from "src/app/shared/services/permissions.service";
import { PermissionsEnum } from "src/app/shared/Models/enums/PermissionsEnum";
import { Router } from "@angular/router";
import { SaveStateTypeEnum } from "src/app/shared/Models/enums/SaveStateTypeEnum";

@Component({
  selector: "app-admin-panel-csv-export-fields",
  templateUrl: "./admin-panel-csv-export-fields.component.html",
  styleUrls: ["./admin-panel-csv-export-fields.component.scss"],
})
export class AdminPanelCsvExportFieldsComponent
  extends FilterableTableComponent<ExportFieldDto>
  implements OnInit
{
  @ViewChild("dt") dataTable: Table;

  navActions: NavAction[] = [];
  saveStates = SaveStateTypeEnum;

  scrollOffsetLandscape: number = 150;
  scrollOffsetPortrait: number = 150;

  allCols = [
    {
      field: "fieldName",
      header: "FIELD NAME",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "caption",
      header: "COLUMN NAME",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "selected",
      header: "SELECTED",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.BOOLEAN,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
  ];

  constructor(
    private _router: Router,
    private _toastService: ToastService,
    private _exportFieldService: ExportFieldService,
    private _deviceCheckService: DeviceCheckService,
    private _permissionsService: PermissionsService
  ) {
    super(_toastService, _deviceCheckService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getExportFields();
    this.navActions = this.initNavActions();
  }

  changeExportFieldSetting(exportField: ExportFieldDto) {
    exportField.state = SaveStateTypeEnum.ongoing;
    this._exportFieldService.changeExportField(exportField).subscribe(
      (res: any) => {
        exportField.state = SaveStateTypeEnum.done;
        setTimeout(() => {
          exportField.state = SaveStateTypeEnum.unkown;
        }, 5000);
      },
      (err) => {
        exportField.state = SaveStateTypeEnum.failed;
      }
    );
  }

  canShowStateInfo(exportField: ExportFieldDto): boolean {
    return (
      exportField &&
      (exportField.state == SaveStateTypeEnum.ongoing ||
        exportField.state == SaveStateTypeEnum.failed ||
        exportField.state == SaveStateTypeEnum.done)
    );
  }

  private initNavActions(): NavAction[] {
    let list: NavAction[] = [];
    if (
      this._permissionsService.allowed(
        PermissionsEnum.ExportFieldsConfiguration
      )
    )
      list.unshift({
        icon: "exit_to_app",
        onClick: () => this.onGoBackButtonClick(),
        tooltip: "Return to CSV Export",
      });

    return list;
  }

  private async onGoBackButtonClick() {
    if (!navigator.onLine) {
      this.toastService.showWarnToast(
        $localize`No internet`,
        $localize`Returning to Export Fields Configuration.`
      );
      return;
    }

    if (this.canConfigureExportFields()) this._router.navigate(["/admin/csv"]);
  }

  private getExportFields() {
    this._exportFieldService
      .getExportFields()
      .pipe(first())
      .subscribe(
        (res) => {
          this.tableValues = res;
          this.globalFilter$.next(this.globalFilter);
        },
        () => this.showErrorWhileGettingExportFields()
      );
  }

  private showErrorWhileGettingExportFields() {
    this.toastService.showErrorToast(
      $localize`Something went wrong`,
      $localize`Something went wrong while retrieving the export fields.`
    );
  }

  private canConfigureExportFields(): boolean {
    return this._permissionsService.allowed(
      PermissionsEnum.ExportFieldsConfiguration
    );
  }
}
